/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesDraftTeamStatusSchema } from "./draftTeamStatusSchema.ts";
import { goodLuckCoreEntitiesMatchSchema } from "./matchSchema.ts";
import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesTournamentTeamMemberSchema } from "./tournamentTeamMemberSchema.ts";
import { goodLuckCoreEntitiesTournamentTeamSourceTypeSchema } from "./tournamentTeamSourceTypeSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentTeamSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().min(1),
  name: z.string().min(1),
  tag: z.string().min(0).max(3).nullish(),
  icon: z.string().nullish(),
  get sourceType() {
    return goodLuckCoreEntitiesTournamentTeamSourceTypeSchema.optional();
  },
  sourceRosterId: z.string().nullish(),
  captainId: z.string().min(1),
  isLookingForPartner: z.optional(z.boolean()),
  initialBudget: z.int().nullish(),
  remainingBudget: z.int().nullish(),
  playersSelected: z.int().nullish(),
  maxPlayers: z.int().nullish(),
  get draftStatus() {
    return goodLuckCoreEntitiesDraftTeamStatusSchema.optional();
  },
  draftOrder: z.int().nullish(),
  isCurrentlyPicking: z.boolean().nullish(),
  lastPickTime: z.iso.datetime().nullish(),
  placement: z.int().nullish(),
  wins: z.int().nullish(),
  losses: z.int().nullish(),
  rosterSnapshot: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get sourceRoster() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  get captain() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get members() {
    return z.array(goodLuckCoreEntitiesTournamentTeamMemberSchema).nullish();
  },
  get participant1Matches() {
    return z.array(goodLuckCoreEntitiesMatchSchema).nullish();
  },
  get participant2Matches() {
    return z.array(goodLuckCoreEntitiesMatchSchema).nullish();
  },
});
